module.exports = __webpack_public_path__ + "img/bg-rightbottom.4715d45d.png";